function addOutlineForChatButton() {
    const intervalId = setInterval(() => {
        const iframe = document.querySelector("iframe#chat-button");
        if (!iframe) return;

        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (!iframeDoc) return;

        const chatButton = iframeDoc.querySelector("#gorgias-chat-messenger-button");
        if (!chatButton) return;

        const style = iframeDoc.createElement("style");
        style.textContent = `
      #gorgias-chat-messenger-button:focus-visible {
        outline: 2px solid #FF0000FF;
  outline-offset: 1px;
      }
    `;
        iframeDoc.head.appendChild(style);

        clearInterval(intervalId);
    }, 300);
}

document.addEventListener("DOMContentLoaded", () => {
    addOutlineForChatButton();
});